import api from "../config/api";

export const getRebates = async (data) => {
  const res = await api.post("rebate/getRebates", data);
  return res.data;
};
